<template>
  <div id="login-container">
    <AuthTabs active="login" />

    <form id="login-form" v-on:submit.prevent="submit">
      <b-input-group class="mb-3">
        <b-input-group-prepend is-text>
          <b-icon icon="person-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model.trim="payload.loginName"
          type="tel"
          inputmode="numeric"
          id="phone"
          name="phone"
          placeholder="Гар утасны дугаар"
        />
      </b-input-group>

      <b-input-group class="mb-3">
        <b-input-group-prepend is-text>
          <b-icon icon="lock-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model.trim="payload.password"
          type="password"
          placeholder="Нууц үг"
        />
      </b-input-group>

      <button
        class="btn col-12 btn-success btn-lg btn-block"
        type="submit"
        variant="primary"
        :disabled="$v.payload.$invalid"
      >
        <b-spinner v-if="isLoading" small></b-spinner>
        <span v-else><a>Нэвтрэх</a> </span>
      </button>
      
      <p class="w-100 mt-2">
        <router-link to="/restore">Нууц үгээ мартсан?</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import OwnerService from "../api-services/owner.service.js";
import user from "../mixins/user";
import { required } from "vuelidate/lib/validators";
import store from "../store";
import Swal from "sweetalert2";
import AuthTabs from "../components/AuthTabs.vue";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  animation: true,
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
});

export default {
  data() {
    return {
      isLoading: false,
      payload: {
        loginName: "",
        password: "",
      },
    };
  },
  mixins: [user],
  components: {
    AuthTabs,
  },
  methods: {
    submit: function () {
      this.isLoading = true;
      const that = this;
      OwnerService.login({
        auth: {
          username: this.payload.loginName,
          password: this.payload.password,
        },
      })
        .then(function (response) {
          if (response.data != null) {
            that.$store.commit("login", {
              id: response.data.id,
              type: response.data.type,
              username: response.data.username,
              password: that.payload.password,
            });
            that.isLoading = false;
            if(response.data.type == "student") {
              that.$router.push({ path: "LevelStage" });
            } else if(response.data.type == "teacher") {
              that.$router.push({ path: "registerUser" });
            } else {
              that.$router.push({ path: "/" });
            }
          }
        })
        .catch(function (error) {
          that.isLoading = false;
          Toast.fire({
            icon: "error",
            title: "нэвтрэх нэр, нууц үг буруу!",
          });
          console.log(error);
        });
    },
  },
  validationStatus(validation) {
    return typeof validation != "undefined" ? validation.$error : false;
  },

  created() {
    localStorage.setItem("memento", 1800);
  },
  validations: {
    payload: {
      loginName: { required },
      password: { required },
    },
  },

  // Энэ компонентруу орохын өмнө орж болох тухай шалгалтыг энд хийж болно
  /**
   * next() -- энэ замруу орохыг зөвшөөрнө
   * next(false) -- энэ замруу орохыг зөвшөөрөхгүй
   * next('/') эсвэл next({ path: '/' }) -- өөр замруу чиглүүлнэ, Жишээ нь нэвтрээгүй байвал нэвтрэх хуудасруу гэх мэт
   * next(error) -- Алдааны мэдээллрүү чиглүүлнэ
   */
  beforeRouteEnter(to, from, next) {
    if (store.state.loggedIn) {
      next("/");
    } else {
      next();
    }
  },
};
</script>
<style lang="postcss" scoped>
#login-container {
  width: 100%;
  padding: 80px 0px 400px 0px;
  font-family: "Roboto", sans-serif;
}
#login-form {
  max-width: 460px;
  margin-right: auto;
  margin-left: auto;
  padding: 20px;
}
.form-group p {
  color: #e20b0bad;
  margin: 0;
  padding: 0;
  text-align: start;
  margin-left: 47px;
}
.input-group-text {
  height: 100%;
}
</style>
